import React from 'react';

const ArrowForward = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 6H10" stroke="#0F1C35" strokeWidth="2" />
    <path d="M5 10.875L10 6L5 1.125" stroke="#0F1C35" strokeWidth="2" />
  </svg>
);

export default ArrowForward;
